import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromNotification from './notification.reducer';
import * as NotificationSelectors from './notification.selectors';
import * as NotificationActions from './notification.actions';

@Injectable()
export class NotificationFacade {
  loading$ = this.store.pipe(
    select(NotificationSelectors.getNotificationLoading)
  );
  // allNotifications$ = this.store.pipe(select(NotificationSelectors.getAllNotifications)); // not used
  unreadNotifications$ = this.store.pipe(
    select(NotificationSelectors.getUnreadNotifications)
  );
  notifications$ = this.store.pipe(
    select(NotificationSelectors.getNotificationEntities)
  );

  constructor(
    private store: Store<fromNotification.NotificationPartialState>
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadNotifications() {

    this.dispatch(NotificationActions.loadNotifications());
  }

  dismissSingle(notificationId: string) {
    this.dispatch(NotificationActions.dismissSingle({ notificationId }));
  }

  dismissAll() {
    this.dispatch(NotificationActions.dismissAll());
  }
}
